import { PushNotificationFormValues } from './types';

export const pushFormDefaultValues: PushNotificationFormValues = {
  title: '',
  mainText: '',
  file: null,
  link: '',
};
